import { render } from "./EntitySelectorUf.vue?vue&type=template&id=34ac6faf"
import script from "./EntitySelectorUf.vue?vue&type=script&lang=ts"
export * from "./EntitySelectorUf.vue?vue&type=script&lang=ts"
script.render = render

export default script